import '../../../styles/interactiveWelcome.css';
import InteractiveWelcomeBody from './interactiveWelcomeBody';
import InteractiveWelcomeLesson from './interactiveWelcomeLesson';


function InteractiveWelcomeModal(props) {

  // Define variables
  const closeModal = props.closeModal;
  const step = props.step;
  const setStep = props.setStep;


  // Screen components
  let bodyElement;
  if( step === 1 ) {
    bodyElement = <InteractiveWelcomeBody closeModal={closeModal} setStep={setStep} />;
  } else {
    bodyElement = <InteractiveWelcomeLesson closeModal={closeModal} />;
  }


  return (
    <>{bodyElement}</>
  );
}

export default InteractiveWelcomeModal;